import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Check } from "lucide-react";
import { useCurrency } from "../../context/CurrencyContext";

const CurrencyDropdown = () => {
  const context = useCurrency();

// sahbas
  // Hooks must be at the top, unconditional sdhjsdj
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    if (isOpen) window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [isOpen]);

  // Safeguard: conditional rendering only
  if (!context) {
    console.warn("CurrencyDropdown rendered outside CurrencyProvider");
    return (
      <div className="text-xs text-amber-600 px-3 py-1.5 bg-amber-50 rounded-lg border border-amber-200">
        Currency not available
      </div>
    );
  }

  const { currency, changeCurrency, currencies = {} } = context;
  const currenciesList = Object.keys(currencies);
  const current = currencies[currency] || { symbol: currency, name: currency };

  const toggle = () => setIsOpen((prev) => !prev);
  const handleSelect = (code) => {
    changeCurrency(code);
    setIsOpen(false);
  };

  // return (
  //   <div className="relative inline-block text-left" ref={dropdownRef}>
  //     {/* Trigger Button */}
  //     <button
  //       type="button"
  //       onClick={toggle}
  //       aria-expanded={isOpen}
  //       aria-haspopup="listbox"
  //       className="group flex items-center gap-1.5 md:px-3 sm:px-4 px-2 py-1 sm:py-2
  //         md:text-sm text-[12px] font-medium text-gray-800
  //         bg-white hover:bg-gray-50 active:bg-gray-100
  //         border border-gray-300 rounded-lg
  //         shadow-sm hover:shadow
  //         transition-all duration-200
  //         focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400"
  //     >
  //       <span className="font-semibold text-gray-900 text-base sm:text-lg">
  //         {current?.symbol || currency}
  //       </span>
  //       <span className="text-gray-600 hidden sm:inline">{currency}</span>
  //       <ChevronDown
  //         size={16}
  //         className={`text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
  //       />
  //     </button>

  //     {/* Dropdown Menu */}
  //     {isOpen && (
  //       <div className="absolute sm:right-0 -right-10 mt-2 w-72 sm:w-80
  //         bg-white border border-gray-200 rounded-xl 
  //         shadow-xl shadow-gray-200/50 
  //         overflow-hidden z-50"
  //       >
  //         <div className="py-1.5 max-h-[320px] overflow-y-auto">
  //           {currenciesList.map((code) => {
  //             const curr = currencies[code];
  //             const isSelected = currency === code;

  //             return (
  //               <div key={code} className="px-4 py-2">
  //                 <button
  //                   type="button"
  //                   onClick={() => handleSelect(code)}
  //                   className={`
  //                     w-full flex items-center justify-between
  //                     text-sm transition-colors duration-150
  //                     ${isSelected
  //                       ? "bg-blue-50 text-blue-700 font-medium"
  //                       : "text-gray-700 hover:bg-gray-50 active:bg-gray-100"}
  //                   `}
  //                 >
  //                   <div className="flex items-center gap-3">
  //                     <span className="text-lg font-semibold w-7 text-center text-gray-900">
  //                       {curr?.symbol || code}
  //                     </span>
  //                     <div className="flex flex-col items-start">
  //                       <span className="font-medium">{code}</span>
  //                       <span className="text-xs text-gray-500">{curr?.name}</span>
  //                     </div>
  //                   </div>

  //                   {isSelected && <Check size={18} className="text-blue-600" />}
  //                 </button>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );

return (
  <div className="relative inline-block text-left" ref={dropdownRef}>
    
    {/* Trigger Button */}
    <button
      type="button"
      onClick={toggle}
      aria-expanded={isOpen}
      aria-haspopup="listbox"
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium
      text-white/80 bg-card border border-white/10 rounded-lg
     hover:text-white transition-all duration-200"
    >
      <span className="font-semibold text-white">
        {current?.symbol || currency}
      </span>

      <span className="hidden sm:inline">{currency}</span>

      <ChevronDown
        size={16}
        className={`transition-transform duration-200 ${
          isOpen ? "rotate-180" : ""
        }`}
      />
    </button>

    {/* Dropdown Menu */}
    {isOpen && (
      <div
        className="absolute sm:right-0 -right-10 mt-2 w-72 sm:w-80
        bg-card border border-white/10 rounded-xl
        shadow-2xl py-2 z-50"
      >
        <div className="max-h-[320px] overflow-y-auto">

          {currenciesList.map((code) => {
            const curr = currencies[code];
            const isSelected = currency === code;

            return (
              <button
                key={code}
                type="button"
                onClick={() => handleSelect(code)}
                className={`w-full flex items-center justify-between
                px-4 py-3 text-sm transition-colors
                ${
                  isSelected
                    ? "bg-page text-white"
                    : "text-white/70 hover:bg-page hover:text-white"
                }`}
              >
                <div className="flex items-center gap-3">

                  <span className="text-lg font-semibold w-7 text-center">
                    {curr?.symbol || code}
                  </span>

                  <div className="flex flex-col items-start">
                    <span className="font-medium">{code}</span>
                    <span className="text-xs text-white/50">
                      {curr?.name}
                    </span>
                  </div>

                </div>

                {isSelected && (
                  <Check size={18} className="text-green-400" />
                )}
              </button>
            );
          })}

        </div>
      </div>
    )}
  </div>
);
};

export default CurrencyDropdown;
// import React, { useState, useRef, useEffect } from "react";
// import { ChevronDown, Check } from "lucide-react";
// import { useCurrency } from "../../context/CurrencyContext";

// const CurrencyDropdown = () => {
//   const context = useCurrency();

//   // Safeguard in case context is missing or not wrapped properly
//   if (!context) {
//     console.warn("CurrencyDropdown rendered outside CurrencyProvider");
//     return (
//       <div className="text-xs text-amber-600 px-3 py-1.5 bg-amber-50 rounded-lg border border-amber-200">
//         Currency not available
//       </div>
//     );
//   }

//   const { currency, changeCurrency, currencies = {} } = context;

//   const [isOpen, setIsOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   const currenciesList = Object.keys(currencies);
//   const current = currencies[currency] || { symbol: currency, name: currency };

//   const toggle = () => setIsOpen((prev) => !prev);

//   const handleSelect = (code) => {
//     changeCurrency(code);
//     setIsOpen(false);
//   };

//   // Close on outside click
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Close on Escape key
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") setIsOpen(false);
//     };
//     if (isOpen) window.addEventListener("keydown", handleEsc);
//     return () => window.removeEventListener("keydown", handleEsc);
//   }, [isOpen]);

//   return (
//     <div className="relative inline-block text-left" ref={dropdownRef}>
//       {/* Trigger Button */}
//       <button
//         type="button"
//         onClick={toggle}
//         aria-expanded={isOpen}
//         aria-haspopup="listbox"
//         className={`
//           group flex items-center gap-1.5 md:px-3 sm:px-4 px-2 py-1 sm:py-2
//           md:text-sm text-[12px] font-medium text-gray-800
//           bg-white hover:bg-gray-50 active:bg-gray-100
//           border border-gray-300 rounded-lg
//           shadow-sm hover:shadow
//           transition-all duration-200
//           focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400
//        `}
//       >
//         <span className="font-semibold text-gray-900 text-base sm:text-lg">
//           {current?.symbol || currency}
//         </span>
//         <span className="text-gray-600 hidden sm:inline">{currency}</span>

//         <ChevronDown
//           size={16}
//           className={`text-gray-500 transition-transform duration-200 ${
//             isOpen ? "rotate-180" : ""
//           }`}
//         />
//       </button>

//       {/* Dropdown Menu */}
//       {isOpen && (
//        <div className={`
//   absolute sm:right-0 -right-10 mt-2 w-72 sm:w-80
//   bg-white border border-gray-200 rounded-xl 
//   shadow-xl shadow-gray-200/50 
//   overflow-hidden z-50
// `}>
//           <div className="py-1.5 max-h-[320px] overflow-y-auto">
//             {currenciesList.map((code) => {
//               const curr = currencies[code];
//               const isSelected = currency === code;

//               return (
//                 <button
//                   key={code}
//                   type="button"
//                   onClick={() => handleSelect(code)}
//                   className={`
//                     w-full flex items-center justify-between 
//                     px-4 py-2.5 text-sm
//                     transition-colors duration-150
//                     ${
//                       isSelected
//                         ? "bg-blue-50 text-blue-700 font-medium"
//                         : "text-gray-700 hover:bg-gray-50 active:bg-gray-100"
//                     }
//                   `}
//                 >
//                   <div className="flex items-center gap-3">
//                     <span className="text-lg font-semibold w-7 text-center text-gray-900">
//                       {curr?.symbol || code}
//                     </span>
//                     <div className="flex flex-col items-start">
//                       <span className="font-medium">{code}</span>
//                       <span className="text-xs text-gray-500">
//                         {curr?.name}
//                       </span>
//                       <div className="flex flex-col items-start">
//                         <span className="font-medium">{code}</span>
//                         <span className="text-xs text-gray-500">{curr.name}</span>
//                       </div>
//                     </div>

//                     {isSelected && (
//                       <Check size={18} className="text-blue-600" />
//                     )}
//                   </button>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CurrencyDropdown;